import styled from 'styled-components';
import iconList from '../../../static/images/tick.png';
import { arrowGreen, blue, greyBorder } from '../../../styles/Variables';

export const SecondHandMachinesAccordionBox = styled.div`
    width: 100%;
`;

export const SecondHandMachinesAccordionButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    padding: 18px 0 13px 0;
    border-bottom: 1px solid ${greyBorder};

    * {
        font-size: 2rem;
        color: ${arrowGreen};
        margin-right: 10px;
    }

    span {
        color: ${blue};
        font-size: 1.5rem;
        font-weight: 700;
        align-self: flex-end;
        line-height: 1.5rem;
        font-family: 'NeueHelveticaPro57Condensed', Helvetica, Arial;
    }
`;

interface SecondHandMachinesAccordionContentProps {
    isActive?: boolean;
}

export const SecondHandMachinesAccordionContent = styled.div<SecondHandMachinesAccordionContentProps>`
    max-width: 100%;
    overflow: hidden;
    opacity: ${(props) => (props.isActive ? '1' : '0')};
    height: ${(props) => (props.isActive ? '100%' : '0')};
    transition: 0.5s ease-in-out;
`;

export const InstructionWrapper = styled.div``;

export const InstructionText = styled.div`
    * {
        font-size: 0.875rem;
        font-family: Arial, Helvetica, sans-serif;

        a {
            color: ${blue};
            font-size: 12px;
        }
    }
`;

export const InstructionList = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;

    * {
        font-family: Arial, Helvetica, sans-serif;
        font-size: 0.875rem;
    }
`;

export const InstructionListElement = styled.li`
    background: url(${iconList}) no-repeat 0% 4px;
    background-size: 15px 15px;
    padding-left: 22px;
    line-height: 1.5rem;

    ::marker {
        color: ${blue};
        font-size: 1.25rem;
        font-weight: 700;
    }
`;
